// extracted by mini-css-extract-plugin
export default {"themeSpacing":"8px","container":"OutsideAnnouncement_container__zu8g","content":"OutsideAnnouncement_content__Ma40","button":"OutsideAnnouncement_button__mWvg"};